import React, { useEffect, useState } from 'react'

import { deleteAttachment, loadAndUpdateVideoInfo } from '../../../../../../../../redux/thunks/multimedia/multimedia'
import { useAppDispatch, useAppSelector } from '../../../../../../../../app/hooks'

import { Attachment, AttachmentType } from '../../../../../../../../@types/types'

import commonStyles from '../AttachmentsList.module.css'
import { useDisableBodyScroll } from '../../../../../../../common/hooks/useDisableBodyScroll'
import VideoControlButtons from './videoControlButtons/VideoControlButtons'
import VideoPreviewModal from './previewModal/VideoPreviewModal'
import VideoThumbnail from './thumbnail/VideoThumbnail'

export const Video: React.FC<{
  videoAttachment: Attachment
}> = ({ videoAttachment }) => {
  const dispatch = useAppDispatch()
  const [previewOpened, setPreviewOpened] = useState(false)
  const closePreview = () => setPreviewOpened(false)
  const handlePlayIconClick = () => setPreviewOpened(true)
  const handleTrashIconClick = async () => {
    await dispatch(deleteAttachment(videoAttachment.id, videoAttachment.source, videoAttachment.size, true))
  }

  useDisableBodyScroll(previewOpened)

  const videoInfos = useAppSelector((state) => state.multimediaFeature.videoInfo)
  const videoInfoSourceUrls = useAppSelector((state) => {
    if (state.multimediaFeature.videoInfo.length > 0) {
      return state.multimediaFeature.videoInfo[0].videoInfo?.videoUrlList ?? []
    } else {
      return []
    }
  })

  const videoInfoSourceTeaserUrl = useAppSelector(
    (state) =>
      state.multimediaFeature.videoInfo?.length > 0 && state.multimediaFeature.videoInfo[0].videoInfo?.teaserUrl
  )
  const offerApiId = useAppSelector(
    (state) =>
      state.multimediaFeature.attachments?.filter((it) => it.attachment?.type == AttachmentType.VIDEO)?.[0]?.attachment
        ?.offerApiId
  )
  const realEstateId = useAppSelector((state) => state.insertionFeature.insertionIdentification.realEstateId)

  useEffect(() => {
    const offerApiIdSelected = offerApiId || videoAttachment.offerApiId
    if (realEstateId && offerApiIdSelected) {
      dispatch(loadAndUpdateVideoInfo(realEstateId, offerApiIdSelected))
    }
  }, [dispatch, offerApiId, realEstateId, videoAttachment.offerApiId])

  const videoSourceWhenUploading = videoInfos.find((videoInfo) => videoInfo.videoId === videoAttachment.videoId)

  return (
    <div className='grid-item one-half'>
      <div className={`${commonStyles.attachmentContainer} align-center border-radius-rounded`}>
        <VideoThumbnail
          data-testid={'video-thumbnail'}
          ariaLabel={videoAttachment.title}
          videoInfoSourceTeaserUrl={videoInfoSourceTeaserUrl}
          videoSourceWhenUploading={videoSourceWhenUploading}
          videoInfoSourceUrls={videoInfoSourceUrls}
        />
        <VideoPreviewModal visible={previewOpened} onClick={closePreview} videoInfoSourceUrls={videoInfoSourceUrls} />
        <VideoControlButtons onPreviewClick={handlePlayIconClick} onDeleteClick={handleTrashIconClick} />
      </div>
    </div>
  )
}

export default Video
